import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectLoading } from "modules/notification"
import ScanHistoryPanelComponent from "./scanHistoryPanel.component"
import { generatePaginationOptions, updateUrlQueryParam } from "lib/helper"
import { useHistory, useRouteMatch } from "react-router-dom"
import { getSerialNumberScanListing } from "modules/serial-number/redux"

function ScanHistoryPanelContainer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const match = useRouteMatch()
  const enc = match.params.enc

  const lang = useSelector(state => state.constant.languages);
  const language = useSelector(state => state.profile.language);
  const token = useSelector(state => state.session.accessToken)
  const snScanLimit = useSelector(state => state.serialNumber.serialNumber.card.scanLimit)
  const scanHistory = useSelector(state => state.serialNumber.serialNumber.scanLog)
  const totalRecords = useSelector(state => state.serialNumber.serialNumber.scanLogTotalCount)
  const isFetching = useSelector(state => selectLoading(state, getSerialNumberScanListing.typePrefix))
  const isError = useSelector(state => state.serialNumber.isLoadingScanError)
  const [paginationOptions, setPaginationOptions] = useState([])
  const [isFilterUpdated, setIsFilterUpdated] = useState(false)
  const [tableFilter, setTableFilter] = useState({
    page: 0,
    rowsPerPage: 10,
    order: "desc",
    column: "created_at" // serial_number|product_name|created_at|location
  })

  const query = new URLSearchParams(window.location.search)
  const tableFilterInitialRef = useRef(true)

  useEffect(() => {
    const isFilter = query.has("is_filter")
    let filter = sessionStorage.getItem(`sn_scan_filter_${enc}`);

    let temp = {...tableFilter}
    if (isFilter && filter) {
      temp = JSON.parse(filter)
      setIsFilterUpdated(true)
    }

    if (isFilter) {
      updateUrlQueryParam(null, ["is_filter"])
    }
    sessionStorage.removeItem(`sn_scan_filter_${enc}`)

    setTableFilter(temp)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!tableFilterInitialRef.current && enc) {
      getData()
    }
    tableFilterInitialRef.current = false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableFilter, enc])

  useEffect(() => {
    setPaginationOptions(generatePaginationOptions(totalRecords, [10, 25, 50, 100, 200, 400]))
  }, [totalRecords])

  const getData = () => {
    dispatch(getSerialNumberScanListing({
      enc,
      length: tableFilter.rowsPerPage,
      start: tableFilter.rowsPerPage * tableFilter.page,
      order: tableFilter.order,
      column: tableFilter.column,
    }))
  }

  const handleChangePage = (event, newPage) => {
    setTableFilter({
      ...tableFilter,
      page: newPage,
      rowsPerPage: tableFilter.rowsPerPage,
    })
    setIsFilterUpdated(true)
  }

  const handleChangeRowsPerPage = event => {
    setTableFilter({
      ...tableFilter,
      page: 0,
      rowsPerPage: event.target.value,
    })
    setIsFilterUpdated(true)
  }

  const changeOrder = (column, order) => {
    setTableFilter({
      ...tableFilter,
      order,
      column
    })
    setIsFilterUpdated(true)
  }

  const handleViewDetail = (url) => {
    if (isFilterUpdated) {
      updateUrlQueryParam({ is_filter: true })
      sessionStorage.setItem(`sn_scan_filter_${enc}`, JSON.stringify(tableFilter));
    }
    history.push(url)
  }

  return (
    <>
      <ScanHistoryPanelComponent 
        scanHistory={scanHistory}
        isFetching={isFetching}
        isError={isError}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={tableFilter.page}
        rowsPerPage={tableFilter.rowsPerPage}
        totalFiltered={totalRecords}
        handleReload={getData}
        paginationOptions={paginationOptions}
        tableFilter={tableFilter}
        changeOrder={changeOrder}
        snScanLimit={snScanLimit}
        language={language}
        enc={enc}
        token={token}
        lang={lang}
        handleViewDetail={handleViewDetail}
      />
    </>
  )
}

export default ScanHistoryPanelContainer
